import React from 'react';

function CustomerDropdown({
  leadCounts,
  handleCustomerFilter,
  isCallcenterLeader,
  isCallcenterMitarbeiter,
  navigate,
  onClose,
  submenuItemStyles
}) {

  const handleFilterClick = (filter) => {
    // Verwende URL-Parameter statt separate Routen - so wie die anderen auch
    switch (filter) {
      case 'all':
        navigate('/kunden');
        break;
      case 'open':
        navigate('/kunden?filter=open'); // URL-Parameter statt separate Route
        break;
      case 'ohne-opt-in':
        navigate('/kunden?filter=ohne-opt-in'); // URL-Parameter statt separate Route
        break;
      case 'on-hold':
        navigate('/kunden?filter=on-hold'); // URL-Parameter statt separate Route
        break;
      case 'termin-abgesagt':
        navigate('/kunden?filter=termin-abgesagt'); // URL-Parameter statt separate Route
        break;
      case 'ne-kunden':
        navigate('/kunden?filter=ne-kunden'); // URL-Parameter statt separate Route
        break;
      case 'spaeter-anrufen':
        navigate('/kunden?filter=spaeter-anrufen'); // URL-Parameter statt separate Route
        break;
      case 'final-nicht-erreicht':
        navigate('/kunden?filter=final-nicht-erreicht');
        break;
      case 'final-abgesagt':
        navigate('/kunden?filter=final-abgesagt');
        break;
      default:
        navigate('/kunden');
    }
    onClose();
  };

  const getBadgeStyle = (type) => {
    const baseStyle = {
      borderRadius: '8px',
      fontSize: '0.7rem',
      padding: '1px 5px',
      fontWeight: '600'
    };

    switch (type) {
      case 'all':
        return { ...baseStyle, backgroundColor: '#e2e8f0', color: '#4a5568' };
      case 'open':
        return { ...baseStyle, backgroundColor: '#c6f6d5', color: '#2f855a' }; // Grün für mit Opt-In
      case 'ohne-opt-in': // NEUER STYLE
        return { ...baseStyle, backgroundColor: '#fefcbf', color: '#d69e2e' }; // Gelb für ohne Opt-In
      case 'on-hold':
        return { ...baseStyle, backgroundColor: '#e2e8f0', color: '#4a5568' };
      case 'termin-abgesagt':
        return { ...baseStyle, backgroundColor: '#fed7d7', color: '#e53e3e' };
      case 'ne-kunden':
        return { ...baseStyle, backgroundColor: '#fed7d7', color: '#e53e3e' };
      case 'spaeter-anrufen':
        return { ...baseStyle, backgroundColor: '#c3dafe', color: '#3182ce' };
      case 'final-nicht-erreicht':
        return { ...baseStyle, backgroundColor: '#bdbdbd', color: '#212121' };
      case 'final-abgesagt':
        return { ...baseStyle, backgroundColor: '#ff6b6b', color: '#ffffff' };
      default:
        return baseStyle;
    }
  };

  console.log("leadCounts : ", leadCounts)

  return (
    <>
      {isCallcenterLeader && (
        <>
          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('all')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Alle Leads</span>
            <span style={getBadgeStyle('all')}>
              {leadCounts.all}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('open')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Offene Leads</span>
            <span style={getBadgeStyle('open')}>
              {leadCounts.open}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('on-hold')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>On Hold</span>
            <span style={getBadgeStyle('on-hold')}>
              {leadCounts.onHold}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('ohne-opt-in')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Ohne Opt-In</span>
            <span style={getBadgeStyle('ohne-opt-in')}>
              {leadCounts.ohneOptIn}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('termin-abgesagt')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Termin Abgesagt</span>
            <span style={getBadgeStyle('termin-abgesagt')}>
              {leadCounts.terminAbgesagt}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('ne-kunden')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>NE Kunden</span>
            <span style={getBadgeStyle('ne-kunden')}>
              {leadCounts.neKunden}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('spaeter-anrufen')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Später anrufen</span>
            <span style={getBadgeStyle('spaeter-anrufen')}>
              {leadCounts.spaeterAnrufen}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('final-nicht-erreicht')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Final nicht erreicht</span>
            <span style={getBadgeStyle('final-nicht-erreicht')}>
              {leadCounts.finalNichtErreicht}
            </span>
          </button>

          <button 
            style={submenuItemStyles}
            onClick={() => handleFilterClick('final-abgesagt')}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#f7fafc'}
            onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
          >
            <span>Final abgesagt</span>
            <span style={getBadgeStyle('final-abgesagt')}>
              {leadCounts.finalAbgesagt}
            </span>
          </button>
        </>
      )}
      
      {/* Callcenter Mitarbeiter haben keine Dropdown-Optionen */}
      {isCallcenterMitarbeiter && !isCallcenterLeader && (
        <div style={{
          padding: '12px 16px',
          color: '#718096',
          fontSize: '14px',
          fontStyle: 'italic'
        }}>
          Keine Filter verfügbar
        </div>
      )}
    </>
  );
}

export default CustomerDropdown;